import CorrectCircleIcon from "#/assets/exam-results/CorrectCircle.svg?url";
import { MathJaxContent } from "#/components/mathjax";
import type { TExamQuestionsForResultSet } from "#/services/rest/gwt/exam-results/descriptive/exam-question-result-set.types";
import { useBreakLG } from "@monta/design-system";
import DifficultyLevel from "../../DifficultyLevel/DifficultyLevel";
import styles from "./answer.module.scss";

type Props = {
  answer: TExamQuestionsForResultSet["answer"];
  correctAnswer?: number;
  difficultyLevelId: TExamQuestionsForResultSet["difficultyLevelId"];
};
const CompleteAnswer = (props: Props) => {
  const { answer, correctAnswer, difficultyLevelId } = props;

  const isLg = useBreakLG();

  return (
    <div className={styles["complete-answer"]}>
      <div className={styles["complete-answer__choice-container"]}>
        {!!correctAnswer && (
          <span className={styles["complete-answer__choice-container__choice"]}>
            <img src={CorrectCircleIcon} alt="درست زدی" />
            <span>گزینه {correctAnswer}</span>
          </span>
        )}

        {!isLg && (
          <div>
            <DifficultyLevel difficultyLevel={difficultyLevelId} />
          </div>
        )}
      </div>

      <MathJaxContent value={answer} />
    </div>
  );
};
export default CompleteAnswer;
